module.exports = __webpack_public_path__ + "static/turtle-creek-house12-ee0e1e10888abf5916358a126a946823.jpg";